import React, { Component } from 'react';
import { Button } from '@trp-rps-rps-shared-web/rps-shared-web-components';
import styled from 'styled-components';
import { keyDown } from 'utils/helpers';

const StyledFooter = styled.div<{ customStyles: string }>`
  &&& {
    ${props => props.customStyles}
  }
  box-shadow: inset 0 1px 0 0 #d7dbde;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 16px 32px;
  background-color: rgba(0, 104, 148, 0.04);
  @media only screen and (max-width: 768px) {
    background-color: #f5f9fb;
    flex-direction: column-reverse;
    justify-content: center;
    padding: 16px;
    height: auto;
    position: relative;
    bottom: 0;
    width: 100%;
    margin-top: auto;
  }
`;

interface Props {
  CTAButtonText: string;
  buttonType?: string;
  handleCTAClick: () => void;
  handleCancelClick?: () => void;
  children?: any;
  hideCancel?: boolean;
  customStyles?: string;
}

class PopoverFooter extends Component<any> {
  divElement: HTMLDivElement | null = null;

  render(): any {
    const {
      handleCTAClick,
      hideModal,
      buttonType,
      CTAButtonText,
      handleCancelClick,
      children,
      hideCancel = false,
      customStyles,
      analyticsId,
      cancelId,
    } = this.props;
    const mq = window.matchMedia('(max-width: 767px)');
    return (
      <StyledFooter customStyles={customStyles}>
        {' '}
        {!hideCancel && (
          <Button
            type="textButton"
            title="Cancel"
            onClick={handleCancelClick ? handleCancelClick : hideModal}
            tabIndex={0}
            onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) =>
              keyDown(e, handleCancelClick ? handleCancelClick : hideModal)
            }
            fitContainerWidth={mq.matches ? true : false}
            style={{ marginRight: mq.matches ? 0 : 16 }}
            id={cancelId}
          />
        )}
        {!mq.matches && children}
        {CTAButtonText && (
          <Button
            type={buttonType ? buttonType : 'primary'}
            title={CTAButtonText}
            onClick={handleCTAClick}
            tabIndex={0}
            onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => keyDown(e, handleCTAClick)}
            fitContainerWidth={mq.matches ? true : false}
            style={{ textAlign: 'center' }}
            id={analyticsId}
          />
        )}
        {mq.matches && children}
      </StyledFooter>
    );
  }
}

export default PopoverFooter;
